import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx/index";
import xlsx, { IColumn, IContent, IJsonSheet, ISettings } from "json-as-xlsx";
import moment from "moment";
import { MovimentacaoBancariaListagemResponse } from "core/features/movimentacoes-bancarias/typings";
import { MovimentacaoBancariaRequestParams } from "features/movimentacoes-bancarias/typings";
import { MovimentacaoBancariaItem } from "core/features/movimentacoes-bancarias/typings";
import { OperacaoEnum } from "resources/enums/conta";

export function exportExcelMovimentacoesBancaria({
  movimentacao,
  filtro,
}: {
  movimentacao: MovimentacaoBancariaListagemResponse;
  filtro: MovimentacaoBancariaRequestParams;
}) {
  const settings: ISettings = {
    fileName: `Movimentações bancárias - ${
      filtro.dataInicio
        ? moment(filtro.dataInicio).format("DD/MM/YYYY")
        : "Desde o início"
    } até ${moment(filtro.dataFim).format("DD/MM/YYYY")}`,
    extraLength: 3,
    writeOptions: {},
  };

  const columnsResumo = getColumnsResumo(filtro.dataFim);
  const columns = getColumns();

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: `Resumo`,
    columns: columnsResumo,
    content: [movimentacao.totais],
  });

  sheets.push({
    sheet: "Movimentações",
    columns: columns,
    content: movimentacao.items.map(defaultContentMapperXlsx),
  });

  xlsx(sheets, settings);
}

function getColumnsResumo(dataFim: string) {
  const columns: IColumn[] = [];

  columns.push({
    label: "Total de receitas",
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaListagemResponse["totais"])
        .receita || 0,
  });

  columns.push({
    label: "Total de despesas",
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaListagemResponse["totais"])
        .despesa || 0,
  });

  columns.push({
    label: "Resultado",
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaListagemResponse["totais"])
        .resultado || 0,
  });

  columns.push({
    label: `Saldo em ${moment(dataFim).format("DD/MM/YYYY")}`,
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaListagemResponse["totais"])
        .saldoDataFim || 0,
  });

  return columns;
}

function getColumns() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Data",
    format: "dd/mm/yyyy",
    value: (row: IContent) =>
      moment(
        (row as unknown as MovimentacaoBancariaItem).dataMovimentacao
      ).format("DD/MM/YYYY"),
  });

  columns.push({
    label: "Descrição",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaItem).descricao || "",
  });

  columns.push({
    label: "Valor",
    format: "#,###0.00",
    value: (row: IContent) => {
      const valor =
        (row as unknown as MovimentacaoBancariaItem).valorLiquido ??
        (row as unknown as MovimentacaoBancariaItem).valor;

      return (row as unknown as MovimentacaoBancariaItem).operacao ===
        OperacaoEnum.Despesa
        ? -valor
        : valor;
    },
  });

  columns.push({
    label: "Conciliado",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaItem).conciliado ? "Sim" : "Não",
  });

  columns.push({
    label: "Saldo",
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as MovimentacaoBancariaItem).saldo,
  });

  return columns;
}
